import { css as p, LitElement as h, nothing as c, html as v } from "lit";
import { property as d, customElement as b } from "lit/decorators.js";
import { classMap as m } from "lit/directives/class-map.js";
import { b as f } from "./styles-scZ6dVz-.js";
var g = Object.defineProperty, u = Object.getOwnPropertyDescriptor, a = (r, t, l, e) => {
  for (var i = e > 1 ? void 0 : e ? u(t, l) : t, n = r.length - 1, s; n >= 0; n--)
    (s = r[n]) && (i = (e ? s(t, l, i) : s(i)) || i);
  return e && i && g(t, l, i), i;
};
let o = class extends h {
  constructor() {
    super(...arguments), this.orientation = "horizontal", this.variant = "solid", this.labelPosition = "center", this.hasSlottedContent = !1;
  }
  handleSlotChange(r) {
    const l = r.target.assignedNodes({ flatten: !0 });
    this.hasSlottedContent = l.some(
      (e) => e.nodeType === Node.ELEMENT_NODE || e.nodeType === Node.TEXT_NODE && e.textContent?.trim()
    ), this.requestUpdate();
  }
  render() {
    const r = {
      divider: !0,
      [this.orientation]: !0,
      [this.variant]: !0,
      [`label-${this.labelPosition}`]: this.hasSlottedContent,
      "no-label": !this.hasSlottedContent
    }, t = this.orientation === "horizontal" ? "separator" : c;
    return v`
      <div class=${m(r)} role=${t} aria-orientation=${this.orientation}>
        <span part="line" class="line"></span>
        <span part="label" class="label">
          <slot @slotchange=${this.handleSlotChange}></slot>
        </span>
        <span part="line" class="line"></span>
      </div>
    `;
  }
};
o.styles = [
  f,
  p`
      :host {
        display: block;
      }

      :host([orientation='vertical']) {
        display: inline-flex;
        height: 100%;
        width: auto;
      }

      .divider {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
      }

      /* Horizontal layout */
      .horizontal {
        flex-direction: row;
        width: 100%;
        margin: var(--r5-divider-spacing, var(--r5-space-4)) 0;
      }

      .horizontal .line {
        flex: 1;
        height: 0;
        border-top-width: var(--r5-divider-thickness, 1px);
        border-top-color: var(--r5-divider-color, var(--r5-border));
      }

      /* Vertical layout */
      .vertical {
        flex-direction: column;
        height: 100%;
        min-height: 1rem;
        margin: 0 var(--r5-divider-spacing, var(--r5-space-4));
      }

      .vertical .line {
        flex: 1;
        width: 0;
        border-left-width: var(--r5-divider-thickness, 1px);
        border-left-color: var(--r5-divider-color, var(--r5-border));
      }

      /* Line variants */
      .solid .line {
        border-style: solid;
      }

      .dashed .line {
        border-style: dashed;
      }

      .dotted .line {
        border-style: dotted;
      }

      /* Label positioning */
      .label {
        padding: 0 var(--r5-space-3);
        white-space: nowrap;
        font-weight: var(--r5-font-medium);
      }

      .vertical .label {
        padding: var(--r5-space-3) 0;
        writing-mode: vertical-lr;
        text-orientation: mixed;
      }

      /* Label position modifiers */
      .label-left .line:first-child {
        flex: 0;
        min-width: 1rem;
      }

      .label-right .line:last-child {
        flex: 0;
        min-width: 1rem;
      }

      /* No label - single line */
      .no-label .line {
        flex: 1;
      }

      .no-label .label {
        display: none;
      }
    `
];
a([
  d({ type: String, reflect: !0 })
], o.prototype, "orientation", 2);
a([
  d({ type: String, reflect: !0 })
], o.prototype, "variant", 2);
a([
  d({ type: String, attribute: "label-position" })
], o.prototype, "labelPosition", 2);
o = a([
  b("ark-divider")
], o);
export {
  o as A
};
//# sourceMappingURL=ark-divider-DGUvDUdz.js.map
